import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { scoreCardData } from "../../features/scoreCard/scoreCardSlice";
import styles from "./ScoreCard.module.css";

import demo2  from '../../assets/images/download (1).jpeg'

const ScoreCard = () => {
  const [team1Score, setteam1Score] = useState(false);
  const [team2Score, setteam2Score] = useState(true);
  const [firstRender, setfirstRender] = useState(true);
  const { match_id } = useParams();

  const dispatch = useDispatch();
  const finalData = useSelector((state) => state.scoreCard?.data?.data);
  const pending = useSelector((state) => state.scoreCard.pending);
  const error = useSelector((state) => state.scoreCard.error);
  // const finalData = data.data;

  // console.log(finalData)

  const finalDataLive = useSelector((state) => state.liveScore?.data?.data);
  const pendingLive = useSelector((state) => state.liveScore.pending);
  const errorLive = useSelector((state) => state.liveScore.error);
  // const finalDataLive = dataLive.data;
  // console.log(finalData);
  const handleClick = (name) => {
    console.log(name);
    switch (name) {
      case "team1Score":
        setteam1Score(!team1Score);

        break;
      case "team2Score":
        setteam2Score(!team1Score);

      default:
        setteam1Score(true);
        setteam2Score(true);
    }
  };
  const[Team1, setTeam1] = useState(1)
  const[currentInning, setcurrentInning]= useState()
  const[Inning1, setInning1] = useState(true)
  const[Inning2, setInning2] = useState(false)
  const[Inning3, setInning3] = useState(false)
  const[Inning4, setInning4] = useState(false)
  const[activeInning, setactiveInning] = useState('inning1')

  const handleClickInning = (inning) =>{

    switch(inning){
      case '1':
        setInning1(true)
    setInning2(false)
    setInning3(false)
    setInning4(false)
    break;
    case '2':
        setInning1(false)
    setInning2(true)
    setInning3(false)
    setInning4(false)
    break;
    case '3':
        setInning1(false)
    setInning2(false)
    setInning3(true)
    setInning4(false)
    break;
    case '4':
        setInning1(false)
    setInning2(false)
    setInning3(false)
    setInning4(true)
    break;
    default:
      return null
    }
    setTeam1(inning)

  }

  useEffect(() => {
    setcurrentInning(parseInt(finalDataLive?.current_inning))
    if (firstRender && !pending) {
      setfirstRender(false);
    }
  }, [pending]);

  useEffect(() => {
    const intervalId = setInterval(()=>{

      dispatch(scoreCardData(match_id));
        },5000)
       
      return ()=> clearInterval(intervalId)
    
    // dispatch(homeData());
    
    
  }, []);

  const inningValueObj = {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
  };

  // useEffect(() => {
     
   
    
  // }, [dispatch, match_id]);

  // if (pending) {
  //   return <div>Loading...</div>;
  // }
  if (error) {
    return <div>Error: {error}</div>;
  }
  if(!finalData || finalData.status === false){
    return <div>Scorecard data will appear here as soon as we get that.</div>;
  }

console.log(currentInning)

  return (
    <>  
    {pending && firstRender ? (
      <div>Loading...</div>
    ) : (
      !firstRender  && <div className={styles.scoreCardWrapper}>
        <div className={styles.inningsWrapper}>
        <div className={styles.teams}>
        <div className= {`${ Inning1 === true  ? styles.active : styles.inactive} ${styles.inningNumber}`} onClick={()=>{handleClickInning('1')}} >
           Ist Inning 
        </div>
        <div className= {`${ Inning2 === true  ? styles.active : styles.inactive} ${styles.inningNumber} ${finalData?.scorecard?.['2']?styles.enable : styles.disabled} `} onClick={()=>{handleClickInning('2')}}>
          2nd Inning         </div>
        <div className= {`${ Inning3 === true  ? styles.active : styles.inactive} ${styles.inningNumber}  ${finalData?.scorecard?.['3']?styles.enable : styles.disabled} `}  onClick={()=>{handleClickInning('3')}} >
           3rd Inning
        </div>
        <div className= {`${ Inning4 === true  ? styles.active : styles.inactive} ${styles.inningNumber}  ${finalData?.scorecard?.['4']?styles.enable : styles.disabled} `} onClick={()=>{handleClickInning('4')}}>
          4th Inning          
        </div>
        
      </div>
      </div>
      {/* <p>{finalData.result ? finalData.result : "No result"}</p> */}

      <div className={styles.team1ScoreCard}>
        <p className={styles.result}>{finalData?.result}</p>
        <div
          className={styles.teamHeading}
         
        >
          <div className={styles.teamFlag}>

            <div className={styles.flagContainer}>
              {/* <img src={finalData?.scorecard[inningValueObj[Team1]]?.team?.flag} alt="" /> */}

              <img src={`https://images.weserv.nl/?url=${finalData?.scorecard?.[inningValueObj[Team1]]?.team?.flag}` } alt={demo2} />
            </div>
            
            <span>{finalData?.scorecard?.[inningValueObj[Team1]]?.team?.short_name}</span>
          </div>
          <div>
            <span>
              { finalData?.scorecard?.[inningValueObj[Team1]]?.team?.score}/
              { finalData?.scorecard?.[inningValueObj[Team1]]?.team?.wicket} (
              { finalData?.scorecard?.[inningValueObj[Team1]]?.team?.over})
            </span>
          </div>
        </div>
        <table >
          <thead>
            <th>BATTER</th>
            <th>R</th>
            <th>B</th>
            <th>4s</th>
            <th>6s</th>
            <th>S/R</th>
          </thead>
          <tbody>
            {
              finalData?.scorecard?.[inningValueObj[Team1]]?.batsman?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span>{item.name}</span> <br />{" "}
                    <span className={styles.outBy}>{item.out_by}</span>
                  </td>
                  <td>{item.run}</td>
                  <td>{item.ball}</td>
                  <td>{item.fours}</td>
                  <td>{item.sixes}</td>
                  <td>{item.strike_rate}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <table
          className={` ${
            styles.extrasAndTotalTable
          }`}
        >
          <tbody>
            <tr>
              <td>
                <span>EXTRAS</span>
                <span>{ finalData?.scorecard?.[inningValueObj[Team1]]?.team?.extras}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>TOTAL</span>
                <span>
                  { finalData?.scorecard?.[inningValueObj[Team1]]?.team?.score}/
                  { finalData?.scorecard?.[inningValueObj[Team1]]?.team?.wicket}(
                  { finalData?.scorecard?.[inningValueObj[Team1]]?.team?.over})
                </span>
              </td>
            </tr>
            <tr className={`${styles.yetToBat} ${((currentInning === 1 && Inning1) || (currentInning === 2 && Inning2) || (currentInning === 3 && Inning3) || (currentInning === 4 && Inning4))? styles.enable : styles.disabled} `}>
              <td >
                <span className={styles.yetToBatHeading}>YET TO BAT</span> <br/>
                {/* to be added */}
                <span className={styles.yetToBatList}>{finalDataLive?.yet_to_bet?.map(item => `${item},${" "}`)}</span> 
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <th>BOWLER</th>
            <th>O</th>
            <th>M</th>
            <th>R</th>
            <th>W</th>
            <th>ECO</th>
          </thead>
          <tbody>
            {
              finalData?.scorecard?.[inningValueObj[Team1]]?.bolwer?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span>{item.name}</span>
                  </td>
                  <td>{item.over}</td>
                  <td>{item.maiden}</td>
                  <td>{item.run}</td>
                  <td>{item.wicket}</td>
                  <td>{item.economy}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <table>
          <thead>
            <th>FALL OF WICKETS</th>
            <th>SCORE</th>
            <th>OVERS</th>
          </thead>
          <tbody>
            {
              finalData?.scorecard?.[inningValueObj[Team1]]?.fallwicket?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span>{item.player}</span>
                  </td>
                  <td>
                    {item.score}-{item.wicket}
                  </td>
                  <td>{item.over}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      



     
    </div>)}
   
    </>
  );
};

export default ScoreCard;
